import parsley from 'parsleyjs'

const $form = $('.job-apply-form')

const setupApplyForm = () => {
  if (!$form.length) {
    return
  }

  $form.parsley()
}

export default {
  can: () => $('body').hasClass('page-careers'),
  run: () => {
    setupApplyForm()
  }
}
